import { Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SubModal from "src/components/pages/Management/Yachts/SubModal/SubModal";
import YachtDetails from "src/components/pages/Management/Yachts/YachtDetails/YachtDetails";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import LinkCards from "src/components/shared/LinkCards/LinkCards";
import { useGetApi } from "src/hooks";
import { Flex, PageContainer } from "src/styled";
import { setYachtId } from "src/utils";

import { type IYacht } from "../Yacht.types";

const dummyData = {
  lastActiveDate: "2023-10-01T12:00:00Z",
  lastActiveUser: "John Doe",
  lastEntryDate: "2023-10-01T12:00:00Z",
  lastEntryTitle: "Engine Check",
  lastEntryUser: "Jane Smith",
  numberOfOpenEntries: "5",
  requiredVerifier: "Captain",
  requiredCoSigner: "First Mate",

  datecreated: "2023-01-01",
  subscriptionStartDate: "2023-01-15",
  bot: "Checklists",
  dateArchived: "2023-09-01",
  activeCrew: "10",
  inactiveCrew: "2",
  archivedCrew: "1",

  lastAuditDate: "2023-08-01",
  lastAuditor: "Auditor Name",
  lastReview: "2023-07-01",
  lastReviewer: "Reviewer Name",
};

const mapData = (data: any) => {
  let list: IYacht[] = [];
  if (data?.data?.content?.list) {
    list = data.data.content.list.map((el: IYacht) => ({
      ...el,
      active: el.active ? "Yes" : null,
    }));
  }

  return {
    ...data?.data?.content,
    list,
    data: {
      ...data?.data?.content?.data,
      ...dummyData,
    },
  };
};

interface Props {
  isFleet?: boolean;
}

const Yacht = ({ isFleet }: Props) => {
  const navigate = useNavigate();
  const { yachtid } = useParams();

  const [opened, { close }] = useDisclosure(false);
  const [infoModalOpened, { close: closeInfoModal }] = useDisclosure(false);
  const [infoModalType] = useState("");

  const { data, isLoading } = useGetApi({
    request: "get-management",
    body: { _sect: "_clients", _yacht: yachtid },
    mapper: mapData,
  });

  useEffect(() => {
    if (yachtid) setYachtId(yachtid);
  }, [yachtid]);

  // DO NOT REMOVE COMMENTS- waiting for implementation
  let cardActions = {
    // Subscriptions: open,
    // Entries: () => handleCustomCardClick("Entries"),
    // Reviews: () => handleCustomCardClick("Reviews"),
    // Audits: () => handleCustomCardClick("Audits"),
    Settings: () => {
      navigate("/settings");
    },
    "Crew Set Up": () => {
      // DO NOT REMOVE- waiting for implementation
      // if (isFleet) navigate(`/settings/crew-set-up?yachtid=${yachtid}`);
      // else navigate("/management/crew-set-up");
      navigate(`/settings/userlist?yachtid=${yachtid}`);
    },
  };
  if (!isFleet) {
    cardActions = {
      ...cardActions,
      ...{
        // "Vessel Particulars": () => handleCustomCardClick("Vessel Particulars"),
        // Cabins: () => handleCustomCardClick("Cabins"),
      },
    };
  }
  // DO NOT REMOVE- waiting for implementation
  // const handleArchive = useCallback(() => {
  //   console.log("Archiving vessel");
  // }, [yachtid]);
  return (
    <PageContainer>
      <SubModal
        opened={opened}
        close={close}
        refetch={() => {}}
        yachtid={yachtid ?? ""}
        params={data?.data}
      />

      <Breadcrumbs border={false} />
      <Flex justify="space-between">
        <Text size="xl">{data?.yacht ?? ""}</Text>
        {/* DO NOT REMOVE- waiting for implementation */}
        {/* <ConfirmationButton */}
        {/*  modalText={`You are about to archive ${data?.yacht ?? "vessel"}`} */}
        {/*  onConfirm={handleArchive}> */}
        {/*  Archive vessel */}
        {/* </ConfirmationButton> */}
      </Flex>
      <LinkCards
        content={isFleet ? [] : data}
        loading={isLoading}
        onClicks={cardActions}
      />
      <YachtDetails
        params={data?.data}
        opened={infoModalOpened}
        close={closeInfoModal}
        type={infoModalType}
      />
    </PageContainer>
  );
};

export default Yacht;
